import request from '@/sheep/request';

const TreatmentApi = {
  // 获取疗程进度列表
  getProgressList: () => {
    return request({
      url: '/operation/thirdparty/moca/app/treatment/progress/list',
      method: 'GET',
      custom: {
        showLoading: true,
        showError: true,
        auth: false,
      },
    });
  },
};

export default TreatmentApi;
